import { Fragment } from "react";
import { createBrowserRouter, RouterProvider } from "react-router";

import { locale, defaultLocale } from "../../helpers/translate";
import { intlLocationBasenameFor } from "../Utils/routing";
import AppLayout from "../AppLayout";
import { routesConfig } from "../Routes/routesConfig";
import MainErrorBoundary from "../ErrorBoundaries/MainErrorBoundary";

// Define whether there's a locale prefix to the router paths, depending on the current
// locale and default locale of the platform.
const basename = intlLocationBasenameFor({ locale, defaultLocale });

const mainRouter = createBrowserRouter(
  [
    {
      path: "/",
      Component: AppLayout,
      children: [...routesConfig, { path: "*", component: Fragment }],
      ErrorBoundary: MainErrorBoundary
    }
  ],
  {
    basename
  }
);

// Note : check whether we need the defineHistoryBasename method
const AppRouter = () => {
  return <RouterProvider router={mainRouter} />;
};

export default AppRouter;
